<template>
  <div id="stock-table-custom" class="mdc-data-table table-custom" @scroll.passive="measureWindow">
    <div>
      <table class="mdc-data-table__table full-table" aria-label="Sector stocks">
        <thead class="top-table">
          <tr class="mdc-data-table__header-row">
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m1">
            <div class="mdc-data-table__header-cell-wrapper">
                <button v-if="!is_sorted" class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 mounth" aria-describedby="protein-status-label" @click="_shortBy(0)">arrow_upward</button>
                <button v-else class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 mounth" aria-describedby="protein-status-label" @click="_shortBy(0)">arrow_downward</button>
                <div class="mdc-data-table__header-cell-label" @click="_shortBy(0)" title="Ticker">Ticker</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true"></div>
            </div>
            </th>
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m1">
            <div class="mdc-data-table__header-cell-wrapper">
                <div class="mdc-data-table__header-cell-label" title="Ver en graficador dinámico">Ver en GD</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true"></div>
            </div>
            </th>
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m1">
            <div class="mdc-data-table__header-cell-wrapper">
                <div class="mdc-data-table__header-cell-label" title="Operaciones">Operaciones</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true"></div>
            </div>
            </th>
            <th v-for="(item, index) in table_header" :key="index" class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m1">
            <div class="mdc-data-table__header-cell-wrapper">
                <button v-if="!is_sorted" class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 mounth" aria-describedby="protein-status-label" @click="_shortBy(index+3)">arrow_upward</button>
                <button v-else class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 mounth" aria-describedby="protein-status-label" @click="_shortBy(index+3)">arrow_downward</button>
                <div class="mdc-data-table__header-cell-label" @click="_shortBy(index+3)" :title="item.name">{{item.sorter}}</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true"></div>
            </div>
            </th>
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
          <tr v-if="windowRange.before" aria-hidden="true"><td :colspan="table_header.length + 3" :style="{ height: windowRange.before + 'px', padding: 0, border: 0 }"></td></tr>
          <tr class="mdc-data-table__row" v-for="{ row, index } in visibleRows" :key="rowKey(row)" @click="_changeTicker(index)" :id="'row' + index" :class="{ 'row-default': index % 2 == 0, 'row-grey': index % 2 != 0, 'mdc-selected-row': row[0] === _g_SelectedTicker }">
            <th v-for="(cel, key) in row" :key='key' scope="row" class="mdc-data-table__cell sector-name">
              <div v-if="key == 0">
                <span :title="'Ticker: ' + cel.ticker 
                  + title_break_line 
                  + 'Pais: ' + cel.country
                  + title_break_line 
                  + 'Índice: ' + cel.index_valor
                  + title_break_line 
                  + 'Divisa: ' + cel.divisa
                  + title_break_line 
                  + 'Sector: ' + cel.sector + ' | ' + cel.industria
                  + title_break_line
                  + 'Tipo de entrada: ' + cel.entry_type_name">{{cel.ticker}}</span>
              </div>
              <div v-else-if="key==1">
                <a @click.stop :href="'/app/graficador-dinamico/ticker/'+row[0].ticker" :aria-label="'Ver gráfico de ' + row[0].ticker" title="Ver en graficador dinámico"><span class="material-icons-outlined">show_chart</span></a>
              </div>
              <div v-else-if="key == 2" class="legacy-table-operations">
                <button v-if="!(_g_User.roles[21] || _g_User.roles[20])" type="button" class="legacy-table-operation alarm"
                  :aria-label="'Añadir ' + row[0].ticker + ' a cartera'" title="Añadir a cartera" @click.stop="openOperation('waiting', row[0], $event)">
                  <span class="material-icons-outlined">{{ row[0].waitings_portfolio_name == null ? 'more_time' : 'schedule' }}</span>
                </button>
                <button type="button" class="legacy-table-operation favorite" :aria-label="'Favoritos de ' + row[0].ticker" title="Favoritos"
                  :style="{ color: (row[0].folder_name || []).length === 1 ? _getColorByWorkspace(row[0].folder_name[0]) : '' }"
                  @click.stop="openOperation('favorites', row[0], $event)">
                  <span class="material-icons-outlined">{{ (row[0].folder_name || []).length ? 'star' : 'star_border' }}</span>
                </button>
              </div>
              <div v-else>
                <span>{{cel}}</span>
              </div>
            </th>
          </tr>
          <tr v-if="windowRange.after" aria-hidden="true"><td :colspan="table_header.length + 3" :style="{ height: windowRange.after + 'px', padding: 0, border: 0 }"></td></tr>
        </tbody>
      </table>
    </div>
    <LegacyTableActionDialog v-if="operation" :action="operation" :stock="selected_ticker" @close="closeOperation" @waiting-added="getStocks" />
  </div>
</template>



<script>
  import { tableWindow } from '@/features/stockchart/models/legacyTableWindow';
  import LegacyTableActionDialog from '@/features/stockchart/components/LegacyTableActionDialog.vue';
  import APICaller from "@/shared/mixins/APICaller.js";
  import Vue from 'vue';
  import { mapMutations, mapGetters } from "vuex";
  import GetStocks from "@/shared/mixins/GetStocks.js";

  export default {
    mixins: [APICaller, GetStocks],
    name: 'StockTableCustom',
    components: {
      LegacyTableActionDialog,
    },
    props: {
      table_header: {type: Array},
      table_body: {type: Array},
      table_obj: {type: Object},
      stocks: {type: Array},
      virtualized: { type: Boolean, default: false }, active: { type: Boolean, default: true }
    },
    watch: {
      active() { this.$nextTick(this.measureWindow); },
      // Rebuild the combined array whenever the table data changes
      table_body(newVal, oldVal) {
        this._arrayCombinator();
      },

      // Also listen for header changes (e.g. when user adds/removes preferences)
      table_header(newVal, oldVal) {
        this._arrayCombinator();
      },
    },
    data() {
      return {
        scrollTop: 0, viewportHeight: 800,
        operation: '',
        selected_ticker: {},

        workspaces_names: [],
        workspaces_colors: [],

        index: 0,
        combinated_array: [],
        is_sorted: false,
        watch_flag: true,
        title_break_line: "\n"
      };
    },
    computed: {
      windowRange() { return this.virtualized ? tableWindow(this.combinated_array.length, this.scrollTop, this.viewportHeight) : { start: 0, end: this.combinated_array.length, before: 0, after: 0 }; },
      visibleRows() { return this.combinated_array.slice(this.windowRange.start, this.windowRange.end).map((row, offset) => ({ row, index: this.windowRange.start + offset })); },
      ...mapGetters(["_g_order_by"]),
      ...mapGetters(["_g_User"]),
      ...mapGetters(["_g_SelectedTicker"]),
    },
    mounted() {
      this._arrayCombinator();
      if (this.virtualized && typeof ResizeObserver !== 'undefined') {
        this.tableResizeObserver = new ResizeObserver(this.measureWindow);
        this.tableResizeObserver.observe(this.$el);
      }
      this.measureWindow();
      this._initWorkspaces();
      
    },
    beforeDestroy() { if (this.tableResizeObserver) this.tableResizeObserver.disconnect(); },
    methods: {
      measureWindow() { if (!this.$el || !this.$el.clientHeight) return; this.scrollTop = this.$el.scrollTop; this.viewportHeight = this.$el.clientHeight; },
      rowKey(row) {
        if (!this.rowKeys) { this.rowKeys = new WeakMap(); this.rowSequence = 0; }
        if (!this.rowKeys.has(row)) this.rowKeys.set(row, ++this.rowSequence);
        return this.rowKeys.get(row);
      },
      iconFavorite(stock) {
        return (stock.favorites == true) ? 'star' : 'star_border';
      },
      openOperation(action, stock, event) {
        this.selected_ticker = stock;
        this.operationTrigger = event.currentTarget;
        this.operation = action;
      },
      closeOperation() {
        this.operation = '';
        this.$nextTick(() => {
          if (this.operationTrigger && this.operationTrigger.isConnected) this.operationTrigger.focus();
        });
      },
      _changeTicker: function(index){
        this.setSelectedActiveTicker(this.combinated_array[index][0]);
        this._changeBackground(index)

      },

      _initWorkspaces: function() {
        let success = response => {
          for (let index = 0; index < response.data.folders.length; index++) {
            this.workspaces_names.push(response.data.folders[index][0]);
            this.workspaces_colors.push(response.data.folders[index][1]);
          }
        }

        let url = '/api/v1/stock-finder/favorite-folder/list';
            
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('023', 'Error recuperando la lista de favoritos.');

        this._getAPICall(url, successHandler, failureHandler);

      },

      _getColorByWorkspace(workspace){
        var index = 0;
        if(this.workspaces_names.includes(workspace)){
          index = this.workspaces_names.indexOf(workspace);
        }
        return this.workspaces_colors[index];
      },

      _startColor: function(){
        const element = document.getElementById("row"+this.index);
        if(element != null) {
          //element.style.background="#CAF4FF";
          document.getElementById("row"+this.index).className += " mdc-selected-row";
        }
      },
      _changeBackground: function(value){

        this.index = value;
      },
      ...mapMutations(['setSelectedTicker']),
      ...mapMutations(["setOrderBy"]),
      setSelectedActiveTicker(ticker) {
        this.setSelectedTicker(ticker);
      },

      _arrayCombinator: function(){
        this.combinated_array = []
        for(var i = 0; i < this.table_body.length; i++){
          let arrayToAdd = [];
          arrayToAdd.push(this.stocks[i])
          arrayToAdd.push("ver-en-gd")
          arrayToAdd.push("iconos")
          for(var j = 0; j< this.table_body[i].length; j++){
            let elem = this.table_body[i]
            arrayToAdd.push(elem[j])
          }
          this.combinated_array.push(arrayToAdd)
        }
        this._checkWhatPreferenceIsOrdered();
      },
      _shortBy: function(index){
        if (!this.combinated_array.length) return;
        if(index == 0){
          if(!this.is_sorted){
            this.combinated_array.sort((a,b) => (a[index].ticker > b[index].ticker) ? 1 : -1)
            this.is_sorted = true;
          }else{
            this.combinated_array.sort((a,b) => (a[index].ticker < b[index].ticker) ? 1 : -1)
            this.is_sorted = false;
          }
        }else{
          // Cells without value ('-') go last and do not decide the column type.
          let without_value = this.combinated_array.filter(row => row[index] === '-');
          if (without_value.length === this.combinated_array.length) without_value = [];
          if (without_value.length) this.combinated_array = this.combinated_array.filter(row => row[index] !== '-');
          const is_int = Number.isInteger(this.combinated_array[0][index]);
          const is_float = this._isFloat(this.combinated_array[0][index]);
          const is_number = is_int || is_float;
          let ends_in_euro = false;
          let ends_in_dollar = false;
          let ends_in_percent = false;
          let ends_in_symbol = false;
          if(!is_number) {
            ends_in_euro = this.combinated_array[0][index].substring(this.combinated_array[0][index].length -1) == "€";
            ends_in_dollar = this.combinated_array[0][index].substring(this.combinated_array[0][index].length -1) == "$";
            ends_in_percent = this.combinated_array[0][index].substring(this.combinated_array[0][index].length -1) == "%";
            ends_in_symbol = ends_in_euro || ends_in_dollar || ends_in_percent;
          }
          
          if(!this.is_sorted){
            if(!is_number && ends_in_symbol){
              this.combinated_array.sort((a,b) => (parseFloat(a[index].substring(0, a[index.length -1])) > parseFloat(b[index].substring(0, a[index.length -1]))) ? 1 : -1)
            }else{
              this.combinated_array.sort((a,b) => {
                  if(a[index] == b[index]) {
                      return a[0].ticker > b[0].ticker ? 1 : -1;
                  } else {
                      return a[index] > b[index] ? 1 : -1;
                  }
                }
              )
            }
            this.is_sorted = true;

          }else{
            if(!is_number && ends_in_symbol){
              this.combinated_array.sort((a,b) => (parseFloat(a[index].substring(0, a[index.length -1])) < parseFloat(b[index].substring(0, a[index.length -1]))) ? 1 : -1)
            }else{
                this.combinated_array.sort((a,b) => {
                  if(a[index] == b[index]) {
                      return a[0].ticker > b[0].ticker ? 1 : -1;
                  } else {
                      return a[index] < b[index] ? 1 : -1;
                  }
                }
              )
            }
            this.is_sorted = false;
          }
          this.combinated_array = this.combinated_array.concat(without_value);
        }
        let ordertype = "";
        if(this.is_sorted){
          ordertype = "asc"
        }else{
          ordertype = "desc"
        }
        let orderBy = []
        if(index == 0){
          orderBy = [ordertype, "Ticker"]
        }else{
          orderBy = [ordertype, this.table_header[index - 3].sorter]
        }
        
        this.setOrderBy(orderBy)
      },

      _isFloat: function(value){
        const rest = value % 1;
        return isNaN(rest) ? false : rest != 0;
      },

      _checkWhatPreferenceIsOrdered: function(){
        let index = 0
        if(this._g_order_by != undefined){
          let temp = []
          if(this._g_order_by[0] == "asc"){
            this.is_sorted = false;
          }else if(this._g_order_by[0] == "desc"){
            this.is_sorted = true
          }
          for(let i = 0; i < this.table_header.length; i++){
            temp.push(this.table_header[i].sorter)
          }
          index = temp.indexOf(this._g_order_by[1])
 
          if(index == -1){
            this._shortBy(0)  
          }else{
            this._shortBy(index+3)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
@use "@material/checkbox"; 
  @use "@material/icon-button"; 
  @use "@material/data-table/data-table";

  @include checkbox.core-styles;
  @include icon-button.core-styles;
  @include data-table.core-styles;
  @include data-table.theme-baseline;

  $color_dark: #000010;
  $back_white: #FFFFFF;
  $back_light_grey: #F3F4F7;

  .mdc-data-table__header-cell {
    text-transform: uppercase;
    background-color: $back_light_grey;}
  .mdc-data-table__header-cell,
  .mdc-data-table__cell{
    color: $color_dark;
    font-size: 12px;
    letter-spacing: 0px;
    text-align: center;}
  .mdc-data-table__row {
    background-color: $back_white;}
  .index-content {
    display: flex;
    justify-content: center;
    flex-direction: column;}
  p {
    margin: 0;}
  .mdc-data-table {
    margin-bottom: 40px;
    width: 100%;}
  .options {
    cursor: pointer;
  }

  .table-custom{
    height: 87vh;
    background-color: #F3F4F7;
    overflow-y: scroll;
    border: 1px solid lightgrey;
    border-radius: 5px;
    width: 97.5%;
  }

  .full-table{
    width: 100%;
    width: -moz-available;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
    width: fill-available;
  }
  .top-table{
    width: 100%;
  }
  #stock-table-custom{
    span{
      font-size: 13px;
      font-family: "Open sans";
    }
    .material-icons{
      font-size: 20px;
      font-family: 'Material Icons Outlined';
    }
    .material-icons-outlined{
      font-size: 20px;
      font-family: 'Material Icons Outlined';
    }
    .mdc-data-table__cell {
      width: 20px;
      min-width: 20px;
      span{
        font-size: 12px;
      }
      .material-icons {
        font-size: 15px;
      }
      .material-icons-outlined {
        font-size: 15px;
      }
    }
    .mdc-data-table__header-cell {
      width: 20px;
      min-width: 20px;
      padding: 0;
      margin: 0;
      .mdc-data-table__header-cell-label{
        font-size: 10px;
      }
      .mdc-data-table__sort-icon-button{
        font-size: 13px;
        width: 10px;
      }
    }

    .row-grey, .row-default{
      cursor: pointer !important;
    }

    .row-grey{
      background-color: var(--color-custom-table-grey);
    }

    .row-default{
      background-color: var(--color-custom-table-default);
    }

    .row-grey:hover{
      background-color: var(--color-custom-table-hover) !important;
    }

    .row-default:hover{
      background-color: var(--color-custom-table-hover) !important;
    }

    .row-grey *, .row-default * {
      color: var(--color-typography-on-background) !important;
    }
  }

  .mdc-data-table__header-cell {
    background-color: var(--color-custom-table-titles) !important;
    color: var(--color-typography-on-background) !important;
  }

  .mdc-data-table__header-cell * {
    color: var(--color-typography-on-background) !important;
  }

  .mdc-selected-row {
    background-color: var(--color-custom-table-selected) !important;
  }
</style>
